// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"fd4cae6e","975":"d0f8db7e"}[chunkId] + ".chunk.js";
};